import { render, staticRenderFns } from "./flowImage.vue?vue&type=template&id=49610f38&scoped=true"
import script from "./flowImage.vue?vue&type=script&lang=js"
export * from "./flowImage.vue?vue&type=script&lang=js"
import style0 from "./flowImage.vue?vue&type=style&index=0&id=49610f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49610f38",
  null
  
)

export default component.exports